import React from 'react';
import CrudTable from '../table/crudtable'
import { photoAliasService } from '../../_services'
import PhotoAliasForm from './photoaliasform.component'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import { SERVER_URL } from '../../config';

function PhotoAlias() {

	const {t} = useTranslation('common');

	const initialState = {
		customerId: -1,
		name: '',
		alias: ''
	}

	const columns = [
	    {
			dataField: 'customerName',
			text: t('photoalias.columns.customer'),
			sort: true
	    },
	    {
			dataField: 'name',
			text: t('photoalias.columns.name'),
			sort: true
	    },
	    {
			dataField: 'alias',
			text: t('photoalias.columns.alias'),
			sort: true
	    }
    ]

	return (
		<div>
            <CrudTable
		        service={photoAliasService}
		        columns={columns}
		        initialState={initialState}
		        form={<PhotoAliasForm />}
		        sort={{dataField: 'customerName', order: 'asc'}}
		        modalSize="lg"
		        urlParams={false}
			/>
		</div>
    )
}

export default PhotoAlias;